/**
 * Created by denis.gusarov on 4/27/2017.
 */

namespace Factive.Game {
    import Tween = Factive.Core.Tween.Tween;
    import Easing = Factive.Core.Tween.Easing;
    import DependenciesContainer = Factive.Core.DependenciesContainer;

    export class MainMenuModel extends BaseModel  {

    }

    export class MainMenuView extends ViewBase {

        public $model: MainMenuModel = null;

        public constructor(private _options,
                           dc:DependenciesContainer) {
            super();
            this.$model = new MainMenuModel();
            dc.singleton("MainMenuData", this.$model);
        }

        public static factory: any = {
            get (opt, dc): MainMenuView {
                return new MainMenuView(opt, dc);
            },
            dependency: ["Options", "DependenciesContainer"]
        };

        public getConfiguration(): IViewConfiguration {
            return <IViewConfiguration>{
                armatureName: "MainScene",
                childViews: {
                    startNewGameButtonView: {
                        view: "RollButtonView",
                        x:100,
                        y:100,
                        options:<IRollButtonOptions>{
                            onPress: () => {
                                this.$childViews.get<RollButtonView>("startNewGameButtonView").display.visible = false;
                                this.AddChild({
                                    view: "GameView",
                                },"gameView")
                            }
                        }
                    }
                }
            };
        }

        protected onContentLoaded(){
        }

        protected onSetLandscape(){

        }

        protected onSetPortrait(){

        }

        public onInitialize(): void {

        }

        public hide(): any{
            let that = this;
            let alpha = {a:1};
            return new Promise(function(resolve, reject){
                let tweenPosition = new Tween(alpha)
                    .to({a: 0}, 300)
                    .easing(Easing.Cubic.InOut);
                tweenPosition.start();
                tweenPosition.onUpdate(() =>{
                    that.alpha = alpha.a;
                });
                tweenPosition.onComplete(() => {
                    resolve();
                });
            });
        }

        public show(): any{
            let that = this;
            let alpha = {a:0};
            return new Promise(function(resolve, reject){
                let tweenPosition = new Tween(alpha)
                    .to({a: 1}, 300)
                    .easing(Easing.Cubic.InOut);
                tweenPosition.start();
                tweenPosition.onUpdate(() =>{
                    that.alpha = alpha.a;
                });
                tweenPosition.onComplete(() => {
                    resolve();
                });
            });
        }
    }

}


// WEBPACK FOOTER //
// src/typescript/Game/Views/MainMenu/MainMenuView.ts